module.exports = __webpack_public_path__ + "img/logo_cna_circulo.59c6b30e.png";